import { render, staticRenderFns } from "./ChooseBookkeepingBusinessClient.vue?vue&type=template&id=e4656e44&"
import script from "./ChooseBookkeepingBusinessClient.vue?vue&type=script&lang=js&"
export * from "./ChooseBookkeepingBusinessClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports